import * as KeyNames from '../api/KeyNames';
import ListUser from '../pages/Admin/list-users';
import ListRole from '../pages/Admin/RoleManagement/list-role';
import { Error404 } from '../pages/Global/Error404';
import { Unauthorized } from '../pages/Global/unauthorized';
import { UnidentifiedUserLocatario } from '../pages/Global/UnidentifiedUserLocatario';
import GestionUsuarios_Locatario from '../pages/UserLocatario/Administracion/GestionUsuariosLocatario';
import ConsultarCierreLocatario from '../pages/UserLocatario/CierreVenta/ConsultarCierreLocatario';
import RegistarCierreLocatario from '../pages/UserLocatario/CierreVenta/RegistarCierreLocatario';
import Dashboard_Locatario from '../pages/UserLocatario/Dashboard/Dashboard';
import EstadoCuenta_Locatario from '../pages/UserLocatario/EstadoCuenta/EstadoCuenta_Locatario';
import Bloquear_Cierre from '../pages/UserMall/Administracion/Bloquear_Cierre';
import Inflacion from '../pages/UserMall/Administracion/Inflacion';
import BitacoraEventos from '../pages/UserMall/BitacoraEventos/BitacoraEventos';
import Dashboard from '../pages/UserMall/Dashboard/Dashboard';
import IndicadoresVentaGeneral from '../pages/UserMall/Indicadores/IndicadoresVentaGeneral.js';
import IndicadoresVentaMensual from '../pages/UserMall/Indicadores/IndicadoresVentasMensual.js';
import Contratos from '../pages/UserMall/Locatarios/Contratos.js';
import Locatarios from '../pages/UserMall/Locatarios/Locatarios.js';
import MapaVistaGeneral_all_in_gestionCategorias from '../pages/UserMall/MapaCalor/All_in/MapaAllIn_gestionCategorias';
import MapaVistaGeneral_all_in from '../pages/UserMall/MapaCalor/All_in/MapaVistaGeneral_all_in';
import MapaVistaGeneral_mantenimiento from '../pages/UserMall/MapaCalor/Mantenimiento/MapaVistaGeneral_mantenimiento';
import MapaVistaGeneral_vacancy from '../pages/UserMall/MapaCalor/Vacancy/MapaVistaGeneral_vacancy';
import MapaVistaGeneral_indicadorVentas from '../pages/UserMall/MapaCalor/VistaGeneral_IndicadorVenta/MapaVistaGeneral_indVta';
import MapaVistaGeneral_reporteCierre from '../pages/UserMall/MapaCalor/VistaGeneral_ReporteCierre/MapaVistaGeneral_rpteCierre';
import BlackList from '../pages/UserMall/Modulos/ListaRoja';
import RegistroAmonestacion from '../pages/UserMall/Operaciones/RegistroAmonestacion';
import VistaAmonestaciones from '../pages/UserMall/Operaciones/VistaAmonestaciones';
import VistaAmonestacionesOperaciones from '../pages/UserMall/Operaciones/VistaAmonestacionesOperaciones';
import AfluenciaDiariaParking from '../pages/UserMall/Reportes/AfluenciaDiariaParking';
import AfluenciaDiariaPeatonal from '../pages/UserMall/Reportes/AfluenciaDiariaPeatonal';
import AfluenciaMensualParking from '../pages/UserMall/Reportes/AfluenciaMensualParking';
import AfluenciaMensualPeatonal from '../pages/UserMall/Reportes/AfluenciaMensualPeatonal';
import ComparativoVentas from '../pages/UserMall/Reportes/ComparativoVentas';
import DiarioComparativoVentas from '../pages/UserMall/Reportes/DiarioComparativoVentas';
import EvolucionVentas from '../pages/UserMall/Reportes/EvolucionVentas';
import EvolucionVentasTienda from '../pages/UserMall/Reportes/EvolucionVentasTienda';
import FlashSemanal from '../pages/UserMall/Reportes/FlashSemanal.js';
import ProvisionVentas from '../pages/UserMall/Reportes/ProvisionVentas.js';
import RankingVentas from '../pages/UserMall/Reportes/RankingVentas';
import RankingVentasPorMall from '../pages/UserMall/Reportes/RankingVentasPorMall';
import VentasDiarias from '../pages/UserMall/Reportes/VentasDiarias';
import VentasGeneral from '../pages/UserMall/Reportes/VentasGeneral';
import VentasGeneralPresupuesto from '../pages/UserMall/Reportes/VentasGeneralPresupuesto';
import VentasM2Locatario from '../pages/UserMall/Reportes/VentasM2Locatario.js';
import VentasPorCategoria from '../pages/UserMall/Reportes/VentasPorCategoria';
import { SCOPES } from './../config/permissions-map';
// import SeleccionarContrato from '../pages/UserLocatario/SeleccionarContrato/SeleccionarContrato';
import GarantiasLocatario from '../pages/UserLocatario/Garantias/GarantiasLocatario';
import EstadoCuenta from '../pages/UserMall/Modulos/EstadoCuenta';
//import ListadoRevisiones from '../pages/UserMall/Garantias/Revisiongarantia/ListadoRevisiones';
import SuperAdmin from '../pages/Admin/SuperAdmin/SuperAdmin';
import ListadoGarantiasRecepcion from '../pages/UserMall/Garantias/RecepcionGarantia/ListadoGarantiasRecepcion';
import ListadoGarantiasRequerimiento from '../pages/UserMall/Garantias/RequerimientoCartaFianza/ListadoGarantiasRequerimiento';
import ListadoGarantiasRevision from '../pages/UserMall/Garantias/RevisionGarantia/ListadoGarantiasRevision';
import ListadoGarantiasRevision2 from '../pages/UserMall/Garantias/RevisionGarantia/ListadoGarantiasRevision2';
import ListadoGarantiasEdicion from '../pages/UserMall/Garantias/EdicionGarantia/ListadoGarantiasEdicion';
import ListadoGarantiasBoveda from '../pages/UserMall/Garantias/BovedaGarantia/ListadoGarantiasBoveda';
import ListadoGarantiasExcepcion from '../pages/UserMall/Garantias/ExcepcionCartaFianza/ListadoGarantiasExcepcion';
import DashboardGarantia from '../pages/UserMall/Garantias/DashboardGarantia/DashboardGarantia';
import GarantiasConfiguracion from '../pages/Admin/SuperAdmin/GarantiasConfiguracion';




const PrivateRoutesConfig = [
    {
        menutitle: "GESTION DE USUARIOS",
        routes: [
            {
                scopes: [SCOPES.GESTION_USUARIOS],
                Component: ListUser,
                icon: 'fi-rr-users-alt',
                path: '/Admin/UsersManagement',
                title: 'Usuarios',
                menuTitle: 'Usuarios'
            }
        ],
        redirects: [
            {
                scopes: [SCOPES.GESTION_USUARIOS],
                from: '/auth',
                to: '/Admin/UsersManagement',
                exact: false
            },
            {
                scopes: [SCOPES.GESTION_USUARIOS],
                from: '/',
                to: '/Admin/UsersManagement',
                exact: true
            }
        ]
    },

    {
        menutitle: "GESTION DE ROLES",
        routes: [
            {
                scopes: [SCOPES.GESTION_ROLES],
                Component: ListRole,
                icon: 'fi-rr-chart-tree',
                path: '/Admin/RoleManagement',
                title: 'Roles & Permisos',
                menuTitle: 'Roles & Permisos'
            }
        ],
        redirects: [
        ]
    },

    {
        menutitle: "CENTRO ADMINISTRATIVO",
        routes: [
            {
                scopes: [SCOPES.DASHBOARD_MALL],
                Component: Dashboard,
                icon: 'fi-rr-apps',
                path: '/dashboard',
                title: 'Dashboard',
                menuTitle: 'Dashboard'
            },
            {
                to: '/indicadoresVentaMensual',
                icon: 'fi-rr-signal-alt-1',
                menuSubTitle: "Indicadores",
                subRoutes: [
                    {
                        scopes: [SCOPES.VENTAS_MENSUAL],
                        Component: IndicadoresVentaMensual,
                        path: '/indicadoresVentaMensual',
                        title: 'Ventas Mensual',
                        menuTitle: 'Ventas Mensual',
                    },
                    {
                        scopes: [SCOPES.VENTAS_GENERAL],
                        Component: IndicadoresVentaGeneral,
                        path: '/ventaGeneral',
                        title: 'Indicador Venta General',
                        menuTitle: 'Venta General',
                    }
                ]
            },
            {
                scopes: [SCOPES.BITACORA_EVENTOS],
                Component: BitacoraEventos,
                icon: 'fi-rr-layers',
                path: '/bitacoraEventos',
                title: 'Bitácora de Eventos',
                menuTitle: 'Bitácora de Eventos',
            }
        ],
        redirects: [
            {
                scopes: [SCOPES.DASHBOARD_MALL],
                from: '/auth',
                to: '/dashboard',
                exact: false
            },
            {
                scopes: [SCOPES.DASHBOARD_MALL],
                from: '/',
                to: localStorage.getItem(KeyNames.PathName) ? localStorage.getItem(KeyNames.PathName) : '/dashboard',
                exact: true
            }
        ],
    },
    {
        menutitle: "LOCATARIOS",
        routes: [
            {
                scopes: [SCOPES.LOCATARIOS],
                icon: 'fi-rr-following',
                path: '/Locatario/Index',
                title: 'Locatarios',
                menuTitle: 'Locatarios',
                Component: Locatarios,
            },
            {
                scopes: [SCOPES.ACTUALIZAR_CONTRATOS],
                icon: 'fi-rr-form',
                path: '/Contrato/ContratoIndex',
                title: 'Actualizar Contratos',
                menuTitle: 'Contratos',
                Component: Contratos,
            },
        ]
    },
    {
        menutitle: "REPORTING",
        routes: [
            {
                scopes: [SCOPES.GENERAL_VENTAS],
                icon: 'fi-rr-shopping-cart-add',
                path: '/Reportes/GeneralVentas',
                title: 'General de Ventas',
                menuTitle: 'General Ventas',
                Component: VentasGeneral
            },
            {
                scopes: [SCOPES.VENTAS_PRESUPUESTO],
                icon: 'fi-rr-chart-pie-alt',
                path: '/Reportes/VentaconContrato',
                title: 'Ventas Presupuesto',
                menuTitle: 'Ventas Presupuesto',
                Component: VentasGeneralPresupuesto
            },
            {
                to: '/Reportes/DiarioComparativoVentas',
                icon: 'fi-rr-list-check',
                menuSubTitle: "Comparativo",
                subRoutes: [
                    {
                        scopes: [SCOPES.DIARIO_COMPARATIVO],
                        path: '/Reportes/DiarioComparativoVentas',
                        title: 'Diario Comparativo',
                        menuTitle: 'Diario Comparativo',
                        Component: DiarioComparativoVentas
                    },
                    {
                        scopes: [SCOPES.COMPARATIVO_VENTAS],
                        path: '/Reportes/ComparativoVentas',
                        title: 'Comparativo Ventas',
                        menuTitle: 'Comparativo Ventas',
                        Component: ComparativoVentas
                    }
                ]
            },
            {
                to: '/Reportes/RankingVentasPorMall',
                icon: 'fi-rr-layers',
                menuSubTitle: "Ranking",
                subRoutes: [
                    {
                        scopes: [SCOPES.RANKING_MALL],
                        path: '/Reportes/RankingVentasPorMall',
                        title: 'Ranking por Mall',
                        menuTitle: 'Ranking por Mall',
                        Component: RankingVentasPorMall,
                    },
                    {
                        scopes: [SCOPES.RANKING_VENTAS],
                        path: '/Reportes/RankVentas',
                        title: 'Ranking de Ventas',
                        menuTitle: 'Ranking Ventas',
                        Component: RankingVentas
                    }
                ]
            },
            {
                scopes: [SCOPES.EVOLUCION_VENTAS],
                icon: 'fi-rr-time-forward',
                path: '/Reportes/EvolucionVentas',
                title: 'Evolución Ventas por CEBE',
                menuTitle: 'Evolución Ventas por CEBE',
                Component: EvolucionVentas
            },
            //corregir bug 
            {
                scopes: [SCOPES.EVOLUCION_VENTAS_TIENDA],
                icon: 'fi-rr-time-forward',
                path: '/Reportes/Tienda',
                title: 'Evolución Ventas por Tienda',
                menuTitle: 'Evolución Ventas por Tienda',
                Component: EvolucionVentasTienda
            },

            {
                scopes: [SCOPES.VENTAS_CATEGORIA],
                icon: 'fi-rr-building',
                path: '/Reportes/VentasPorCategoria',
                title: 'Ventas Categoría',
                menuTitle: 'Ventas Categoría',
                Component: VentasPorCategoria
            },
            {
                scopes: [SCOPES.VENTAS_LOCATARIOS_M2],
                Component: VentasM2Locatario,
                icon: 'fi-rr-layout-fluid',
                path: '/Reportes/VentasM2xLocatario',
                title: 'Ventas Locatarios m2',
                menuTitle: 'Ventas m2',
            },

            {
                scopes: [SCOPES.VENTAS_POR_DIA],
                icon: ' fi-rr-time-twenty-four',
                path: '/Reportes/ReporteDiaIndex',
                title: 'Ventas por Día',
                menuTitle: 'Ventas por Día',
                Component: VentasDiarias
            },

            {
                scopes: [SCOPES.REPORTE_PROVISION],
                icon: 'fi-rr-box-alt',
                path: '/Reportes/ReporteProvisionVentas',
                title: 'Reporte X Provisión',
                menuTitle: 'Provisión de Ventas',
                Component: ProvisionVentas,
            },
            {
                scopes: [SCOPES.REPORTE_PROYECCIÓN],
                icon: 'fi-rr-book-alt',
                path: '/Reportes/ReporteProyeccionesIndex',
                title: 'Reporte X Proyección',
                menuTitle: 'Flash Semanal',
                Component: FlashSemanal,
            },
            {
                icon: 'fi-rr-earnings',
                path: '/Reportes/AfluenciaDiariaPeatonal',
                menuSubTitle: "Afluencia",
                subRoutes: [
                    {
                        scopes: [SCOPES.AFLUENCIA_DIARIA_PEATONAL],
                        path: '/Reportes/AfluenciaDiariaPeatonal',
                        title: 'Afluencia Diaria',
                        menuTitle: 'Diaria Peatonal',
                        Component: AfluenciaDiariaPeatonal,
                    },
                    {
                        scopes: [SCOPES.AFLUENCIA_MENSUAL_PEATONAL],
                        path: '/Reportes/AfluenciaMensualPeatonal',
                        title: 'Afluencia  Mensual',
                        menuTitle: 'Mensual Peatonal',
                        Component: AfluenciaMensualPeatonal,
                    },
                    {
                        scopes: [SCOPES.AFLUENCIA_DIARIA_PARKING],
                        path: '/Reportes/AfluenciaDiariaParking',
                        title: 'Afluencia  Diaria Parking',
                        menuTitle: 'Diaria Parking',
                        Component: AfluenciaDiariaParking,
                    },
                    {
                        scopes: [SCOPES.AFLUENCIA_MENSUAL_PARKING],
                        path: '/Reportes/AfluenciaMensualParking',
                        title: 'Afluencia Mensual Parking',
                        menuTitle: 'Mensual Parking',
                        Component: AfluenciaMensualParking,
                    }
                ]
            }
        ]
    },
    {
        menutitle: "MODULOS",
        routes: [
            {
                scopes: [SCOPES.LISTA_ROJA],
                icon: 'fi-rr-shield-exclamation',
                path: '/Blacklist/Index',
                title: 'Lista Roja',
                menuTitle: 'Lista Roja',
                Component: BlackList,
            },
            {
                scopes: [SCOPES.ESTADO_CUENTA],
                icon: 'fi-rr-reflect',
                path: '/Estadocuenta/Index',
                title: 'Estado de Cuenta',
                menuTitle: 'Estado de Cuenta',
                Component: EstadoCuenta,
            }
        ]
    },
    {
        menutitle: "MAPA DE CALOR",
        routes: [
            {
                to: '/mapas/vistaGeneral',
                icon: 'fi-rr-list-check',
                menuSubTitle: "Vista General",
                subRoutes: [
                    {
                        scopes: [SCOPES.MAPA_CALOR_INDICADOR_VENTAS],
                        icon: 'fi-rr-thermometer-half',
                        path: '/mapas/vistaGeneralIndicadorVentas',
                        title: 'Indicador de Ventas',
                        menuTitle: 'Indicador Ventas',
                        Component: MapaVistaGeneral_indicadorVentas,
                    },
                    {
                        scopes: [SCOPES.MAPA_CALOR_REPORTE_CIERRE],
                        icon: 'fi-rr-thermometer-half',
                        path: '/mapas/vistaGeneralReporteCierre',
                        title: 'Reporte de Cierre',
                        menuTitle: 'Reporte Cierre',
                        Component: MapaVistaGeneral_reporteCierre,
                    }
                ]
            },
            {
                scopes: [SCOPES.MAPA_CALOR_VACANCY],
                icon: 'fi-rr-thermometer-half',
                path: '/mapas/vacancy',
                title: 'Vacancy ',
                menuTitle: 'Vacancy ',
                Component: MapaVistaGeneral_vacancy,
            },
            {
                to: '/mapas/allIn',
                icon: 'fi-rr-thermometer-half',
                menuSubTitle: "All In",
                subRoutes: [
                    {
                        scopes: [SCOPES.MAPA_CALOR_ALL_IN],
                        icon: 'fi-rr-thermometer-half',
                        path: '/mapas/allInVista',
                        title: 'Vista Mapa All In',
                        menuTitle: 'Mapa All In',
                        Component: MapaVistaGeneral_all_in,
                    },
                    {
                        scopes: [SCOPES.MAPA_CALOR_ALL_IN, ""],
                        icon: 'fi-rr-thermometer-half',
                        path: '/mapas/allInGestionCategoria',
                        title: 'Gestión de Categorías Mapa All In',
                        menuTitle: 'Gestión de Categorías',
                        Component: MapaVistaGeneral_all_in_gestionCategorias,
                    }
                ]
            },
            {
                scopes: [SCOPES.MAPA_CALOR_MANTENIMIENTO],
                icon: 'fi-rr-broom',
                path: '/Mapas/ModificarMapas',
                title: 'Mantenimiento',
                menuTitle: 'Mantenimiento',
                Component: MapaVistaGeneral_mantenimiento,
            }
        ]
    },
    {
        menutitle: "OPERACIONES",
        routes: [
            {
                scopes: [SCOPES.REGISTRO_AMONESTACION],
                icon: 'fi-rr-thermometer-half',
                path: '/Amonestacion/Registro',
                title: 'Registro de Amonestación',
                menuTitle: 'Registro de Amonestación',
                Component: RegistroAmonestacion,
            },
            {
                scopes: [SCOPES.VISTA_AMONESTACIONES],
                icon: 'fi-rr-bell-ring',
                path: '/Amonestacion/Aprobacion',
                title: 'Vista de Amonestaciones',
                menuTitle: 'Amonestaciones',
                Component: VistaAmonestaciones,
            },
            {
                scopes: [SCOPES.APROBADAS_AMONESTACIONES],
                icon: 'fi-rr-badge-check',
                path: '/Amonestacion/AprobadasOperaciones',
                title: 'Amonestaciones Aprobadas',
                menuTitle: 'Amonestaciones Aprobadas',
                Component: VistaAmonestacionesOperaciones,
            },
            {
                to: '/Return/Expected',
                icon: 'fi-rr-id-badge',
                menuSubTitle: "Administración",
                subRoutes: [
                    {
                        scopes: [SCOPES.INFLACION],
                        path: '/Inflacion/Index',
                        title: 'Inflación',
                        menuTitle: 'Inflación',
                        Component: Inflacion,
                    },
                    {
                        scopes: [SCOPES.BLOQUEAR_CIERRES],
                        path: '/Bloqueo/Index',
                        title: 'Bloquear Cierres',
                        menuTitle: 'Bloquear Cierres',
                        Component: Bloquear_Cierre,
                    }
                ]
            }
        ]
    },
    {
        menutitle: "GARANTÍAS",
        routes: [
            {
                scopes: [SCOPES.GARANTIAS_REVISION_GARANTIAS],
                icon: 'fi-rr-list-check',
                path: '/garantias/listado_garantias_revision',
                title: 'Revisión de Garantías',
                menuTitle: 'Revisión de Garantías',
                Component: ListadoGarantiasRevision,
            },
            {
                scopes: [SCOPES.GARANTIAS_REVISION_GARANTIAS_2],
                icon: 'fi-rr-list-check',
                path: '/garantias/listado_garantias_rev_2',
                title: 'Revisión de Garantías 2',
                menuTitle: 'Revisión de Garantías 2',
                Component: ListadoGarantiasRevision2,
            },
            {
                // scopes: [SCOPES.GARANTIAS_RECEPCION_GARANTIA],
                scopes: [SCOPES.GARANTIAS_RECEPCION_GARANTIA],
                icon: 'fi-rr-hand-holding-box',
                path: '/garantias/listado_garantias_recepcion',
                title: 'Recepción de Garantía',
                menuTitle: 'Recepción de Garantía',
                Component: ListadoGarantiasRecepcion,
            },
            {
                // scopes: [SCOPES.GARANTIAS_RECEPCION_GARANTIA],
                scopes: [SCOPES.GARANTIAS_UBICACION_CARTA_FIANZA],
                icon: 'fi-rr-home-location',
                path: '/garantias/listado_garantias_boveda',
                title: 'Bóveda de Garantías',
                menuTitle: 'Bóveda de Garantías',
                Component: ListadoGarantiasBoveda,
            },
            {
                // scopes: [SCOPES.GARANTIAS_RECEPCION_GARANTIA],
                scopes: [SCOPES.GARANTIAS_EXCEPCION_GARANTIA],
                icon: 'fi-rr-replace',
                path: '/garantias/listado_garantias_excepcion',
                title: 'Excepción de Garantía',
                menuTitle: 'Excepción de Garantía',
                Component: ListadoGarantiasExcepcion,
            },
            {
                scopes: [SCOPES.GARANTIAS_REQUERIMIENTO_CARTA_FIANZA],
                icon: 'fi-rr-rectangle-list',
                path: '/garantias/listado_garantias_requerimiento',
                title: 'Requerimiento de CF',
                menuTitle: 'Requerimiento de CF',
                Component: ListadoGarantiasRequerimiento,
            },
            {
                // scopes: [SCOPES.GARANTIAS_RECEPCION_GARANTIA],
                scopes: [SCOPES.GARANTIAS_DASHBOARD],
                icon: 'fi-rr-dashboard',
                path: '/garantias/dashboard_garantia',
                title: 'Dashboard Garantía',
                menuTitle: 'Dashboard Garantía',
                Component: DashboardGarantia,
            }
        ]
    },
    {
        menutitle: "SUPER ADMIN",
        routes: [
            {
                scopes: [SCOPES.SUPERADMIN_CONFIG],
                icon: 'fi-rr-settings',
                path: '/configuracion-global',
                title: 'Configuración Global',
                menuTitle: 'Configuración Global',
                Component: SuperAdmin,
            },
            {
                scopes: [SCOPES.GARANTIAS_CONFIGURACION],
                icon: 'fi-rr-settings',
                path: '/configuracion-garantias',
                title: 'Configuración de Parámetros',
                menuTitle: 'Configuración de Parámetros',
                Component: GarantiasConfiguracion,
            },
            {
                scopes: [SCOPES.GARANTIAS_EDICION],
                icon: 'fi-rr-edit',
                path: '/garantias/listado_garantias_edicion',
                title: 'Edición de Garantías',
                menuTitle: 'Edición de Garantías',
                Component: ListadoGarantiasEdicion,
            }
        ]
    },
    {
        menutitle: "DASHBOARD",
        routes: [
            {
                scopes: [SCOPES.DASHBOARD_LOCATARIO],
                Component: Dashboard_Locatario,
                icon: 'fi-rr-apps',
                path: '/locatario/dashboard',
                title: 'Dashboard Locatario',
                menuTitle: 'Dashboard Locatario'
            }
        ],
        redirects: [
            {
                scopes: [SCOPES.DASHBOARD_LOCATARIO],
                from: '/auth',
                to: '/locatario/dashboard',
                exact: false
            },
            {
                scopes: [SCOPES.DASHBOARD_LOCATARIO],
                from: '/',
                to: localStorage.getItem(KeyNames.PathName) ? localStorage.getItem(KeyNames.PathName) : '/locatario/dashboard',
                exact: true
            }
        ]
    },
    {
        menutitle: "CIERRE DE VENTAS",
        routes: [

            {
                scopes: [SCOPES.REGISTRAR_CIERRE_VENTA_LOCATARIO],
                Component: RegistarCierreLocatario,
                path: '/cierreVentas/registrarCierre',
                title: 'Registrar Cierre',
                icon: 'fi-rr-clock',
                menuTitle: 'Registrar Cierre'
            },
            {
                scopes: [SCOPES.CONSULTA_CIERRE_LOCATARIO],
                Component: ConsultarCierreLocatario,
                path: '/cierreVentas/consultarCierre',
                title: 'Consultar Cierre',
                icon: 'fi-rr-clock',
                menuTitle: 'Consultar Cierre'
            }

        ],
        redirects: [
        ]
    },
    {
        menutitle: "GARANTÍAS",
        routes: [
            {
                scopes: [SCOPES.GARANTIAS_LOCATARIO],
                icon: 'fi-rr-thermometer-half',
                path: '/garantias',
                title: 'Garantías',
                menuTitle: 'Garantías',
                Component: GarantiasLocatario,
            }
        ]
    },
    {
        menutitle: "ESTADO DE CUENTA",
        routes: [
            {
                scopes: [SCOPES.ESTADO_CUENTA_LOCATARIO],
                Component: EstadoCuenta_Locatario,
                icon: 'fi-rr-dollar',
                path: '/estadoCuenta/EstadoCuenta',
                title: 'Estado de Cuenta Locatario',
                menuTitle: 'Estado de Cuenta Locatario'
            }
        ],
        redirects: [
        ]
    },
    {
        menutitle: "ADMINISTRACION",
        routes: [
            {
                scopes: [SCOPES.GESTION_USUARIOS_LOCATARIO],
                Component: GestionUsuarios_Locatario,
                icon: 'fi-rr-fingerprint',
                path: '/locatario/administracion',
                title: 'Gestión de Usuarios Locatario',
                menuTitle: 'Gestión de usuarios Locatario'
            }
        ],
        redirects: [
        ]
    },
    {
        routes: [
            // {
            //     scopes: [],
            //     Component: SeleccionarContrato,
            //     icon: '/media/uicons-regular-rounded/svg/fi-rr-shield-interrogation.svg',
            //     path: '/locatario/seleccionar-contrato',
            //     title: 'seleccionar contrato'
            // },
            {
                scopes: [],
                Component: Unauthorized,
                icon: '/media/uicons-regular-rounded/svg/fi-rr-shield-interrogation.svg',
                path: '/unauthorized',
                title: 'Unauthorized'
            },
            {
                scopes: [],
                Component: Error404,
                icon: '/media/uicons-regular-rounded/svg/fi-rr-shield-interrogation.svg',
                path: '/error/404',
                title: 'Error'
            },
            {
                scopes: [],
                Component: UnidentifiedUserLocatario,
                icon: '/media/uicons-regular-rounded/svg/fi-rr-shield-interrogation.svg',
                path: '/UnidentifiedUserLocatario',
                title: 'Unidentified User Locatario'
            }
        ],
        // redirects: [
        //     {
        //         to: '/error/404'
        //     }
        // ]
    }
];
export default PrivateRoutesConfig;